import React from 'react';

import ExternalLinkCard from 'src/common/components/external-link';
import { ViewMicrosoftFile } from 'src/common/ViewMicrosoftFile';
import { useStepEditorContext } from 'src/store/step-editor';
import { isMicrosoftOfficeType } from 'src/utils/mime';

interface Props {
  onExternalLinkNavigate?: () => void;
  disabled?: boolean;
}

const StepEditorExternalFile = (props: Props) => {
  const linkProperties = useStepEditorContext((state) => state.link);
  const { externalFile } = useStepEditorContext((state) => state.previewObject);
  const link = {
    ...externalFile,
    title: linkProperties['title'] || externalFile['name'],
    description: linkProperties['description'] || externalFile['description'],
    hide_image: linkProperties['hide_image'] || externalFile['hide_image'],
  };

  const type = externalFile?.type;

  if (type && isMicrosoftOfficeType(type)) {
    return <ViewMicrosoftFile url={externalFile.url} className="rounded-lg" />;
  }

  return <ExternalLinkCard isThumbnailHidden={link.hide_image} link={link} isURLHidden {...props} isAttachment fileAssetId={externalFile?.id} />;
};

export default StepEditorExternalFile;
